const BASE =
  "https://conextcrm-uploads.s3.eu-north-1.amazonaws.com/shared-assets";

export const TARJETA_DEFAULT = `${BASE}/tarjeta_visita.jpeg`;

const TARJETAS_POR_USUARIO = {
  trini: `${BASE}/tarjeta_trinidad.png`,
  manuel: `${BASE}/tarjeta_manuel.png`,
  david: `${BASE}/tarjeta_trinidad.png`,
  pablo: `${BASE}/tarjeta_pablo.png`,
};

export function getTarjetaUrl(userId) {
  // Acepta userId con o sin dominio (pablo@verticetrade.es → pablo)
  const key = (userId || "").split("@")[0].toLowerCase();
  return TARJETAS_POR_USUARIO[key] || TARJETA_DEFAULT;
}

// Teléfono/WhatsApp DIRECTO del comercial (el de su tarjeta y QR). La plantilla
// tarjeta_visita_v3 lo inyecta en {{3}} para que el cliente escriba o llame al
// comercial, no al número de Conext. Debe coincidir con el número impreso en la
// tarjeta de cada usuario.
const TELEFONOS_POR_USUARIO = {
  trini: "+34 660 29 11 85",
  david: "+34 660 29 11 85",
  manuel: "+34 618 39 11 63",
  pablo: "+34 656 98 77 97",
};

// Devuelve el teléfono del comercial o `null` si no está mapeado (en ese caso NO
// se debe enviar la tarjeta, para no mandar un número equivocado).
export function getTelefonoComercial(userId) {
  const key = (userId || "").split("@")[0].toLowerCase();
  return TELEFONOS_POR_USUARIO[key] || null;
}
